import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchAppointments } from '@/api/appointments/appointmentsApi';
import { APPOINTMENTS_QUERY_KEY } from '@/constants/queryKeys';
import type { Appointment } from '@/api/appointments/appointmentsApi.types';

export function useAppointmentsQuery(): UseQueryResult<Appointment[], Error> {
  return useQuery({
    queryKey: APPOINTMENTS_QUERY_KEY,
    queryFn: fetchAppointments,
  });
}
